/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} League_Standings_Mode_LabelInputs */



/**
* | output |
* | --- |
* | "Standings Mode" |
*
* @param {League_Standings_Mode_LabelInputs} inputs
* @param {{ locale?: "en" | "fr" | "es" | "pt" | "it" }} options
* @returns {LocalizedString}
*/
export const league_standings_mode_label = /** @type {((inputs?: League_Standings_Mode_LabelInputs, options?: { locale?: "en" | "fr" | "es" | "pt" | "it" }) => LocalizedString) & import('../runtime.js').MessageMetadata<League_Standings_Mode_LabelInputs, { locale?: "en" | "fr" | "es" | "pt" | "it" }, {}>} */ ((inputs = {}, options = {}) => {
	void inputs;
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return /** @type {LocalizedString} */ ("Mode de classement")
	if (locale === "es") return /** @type {LocalizedString} */ ("Modo de clasificación")
	if (locale === "pt") return /** @type {LocalizedString} */ ("Modo de classificação")
	if (locale === "it") return /** @type {LocalizedString} */ ("Modalità classifica")
	return /** @type {LocalizedString} */ ("Standings Mode")
});